var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONStruct, nullable, property } from 'badphraim/data/JSONStruct';
export class ewJSONInvoice2Line extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.eier = 0;
        /** @override */ this.sum = 0;
        /** @override */ this.sum_inc_mva = 0;
    }
}
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONInvoice2Line.prototype, "antall", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONInvoice2Line.prototype, "art_id", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONInvoice2Line.prototype, "artnr", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONInvoice2Line.prototype, "bruker", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONInvoice2Line.prototype, "dato", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONInvoice2Line.prototype, "eier", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONInvoice2Line.prototype, "id", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONInvoice2Line.prototype, "klipp", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONInvoice2Line.prototype, "mva", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONInvoice2Line.prototype, "mva_sats", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONInvoice2Line.prototype, "pris", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONInvoice2Line.prototype, "rabatt_pst", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONInvoice2Line.prototype, "sortering", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONInvoice2Line.prototype, "sum", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONInvoice2Line.prototype, "sum_inc_mva", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONInvoice2Line.prototype, "tekst", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONInvoice2Line.prototype, "tittel", void 0);
